import { render, staticRenderFns } from "./actionOrderOutsourcing.vue?vue&type=template&id=18d739b7&"
import script from "./actionOrderOutsourcing.vue?vue&type=script&lang=js&"
export * from "./actionOrderOutsourcing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports